import moment from 'moment';

export const TASK_DEFAULTS = {
  title: '',
  detail: '',
  contactId: null,
  dueDate: moment().parseZone(),
};
